import { getQueryParams } from '../utils/url'
import { getElementAttributes } from '../utils/element'
import { Customizations } from './types'
import { hooksCustomizatioKeyPrefix } from '../services/hooks'

export const getCustomizations = (customizations: Customizations, element: HTMLElement) => {
  const urlParams = filterUrlParams(getQueryParams())
  const elementAttributes = getElementAttributes(element)
  return {
    ...customizations,
    ...elementAttributes,
    ...urlParams
  }
}

const filterUrlParams = (params: Record<string, string>) => {
  for (const key in params) {
    if (isBlocked(key)) {
      delete params[key]
    }
  }
  return params
}

const isBlocked = (key: string): boolean => {
  return key.indexOf(hooksCustomizatioKeyPrefix) === 0
}
